import React from 'react'
import FilterIcon from '../../../../../icons/filter.svg'

class TypeFilter extends React.Component {
  constructor(props) {
    super(props)

    this.allTag = {
      label: 'Alles',
      type: 'all',
      count: null,
    }

    this.state = {
      options: [], // will be set on mount
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.options !== this.props.options) {
      this.setState({
        options: nextProps.options,
      })
    }
  }

  findOption(type) {
    let option
    this.state.options.map(o => {
      if (o.type == type) {
        option = o
      }
    })
    return option
  }

  onButtonClick(evt, opt) {
    evt.preventDefault()

    let resetAll = false
    let options = this.state.options.map(o => {
      if (opt.type === 'all' && o.type === 'all') {
        return { ...o, active: true }
      } else if (opt.type === 'all') {
        return { ...o, active: false }
      }

      if (opt.type === o.type) {
        if (!o.active === true) {
          resetAll = true
        }
        return { ...o, active: !o.active }
      }
      return o
    })

    if (resetAll) {
      options = options.map(o => {
        if (o.type === 'all') {
          return { ...o, active: false }
        }
        return o
      })
    }

    const activeCount = options.filter(o => o.active)
    // no more active options set highlight all button
    if (activeCount.length === 0) {
      options = options.map(o => {
        if (o.type === 'all') {
          return { ...o, active: true }
        }
        return o
      })
    }

    this.setState(
      {
        options,
      },
      () => {
        this.props.onUpdate(
          this.state.options.filter(o => o.active && o.type !== 'all')
        )
      }
    )
  }

  render() {
    return (
      <div className="wwp3-type-filter">
        <FilterIcon />
        <ul className="wwp3-type-filter__list">
          <li>
            {this.state.options.map(opt => {
              return (
                <button
                  className={`wwp3-filter__button ${
                    opt.active ? 'wwp3-active' : ''
                  }`}
                  key={opt.type}
                  type="button"
                  onClick={evt => this.onButtonClick(evt, opt)}
                >
                  {opt.label} {opt.count !== null && '(' + opt.count + ')'}
                </button>
              )
            })}
          </li>
        </ul>
      </div>
    )
  }
}
export default TypeFilter



// WEBPACK FOOTER //
// src/assets/js/front-end/apps/search/components/TypeFilter.js